/* eslint-disable react/jsx-no-duplicate-props */
import { useState } from 'react';
import { RemoveRedEye, VisibilityOff, Search } from '@mui/icons-material';
import { toPattern } from 'vanilla-masker';
import { useController } from 'react-hook-form';
import ErrorIcon from '@mui/icons-material/Error';
import { TextField, TextFieldProps, IconButton } from '@mui/material';
import { Container } from './styles';

type Props = TextFieldProps & {
  errorText?: string;
  mask?: string;
  name: string;
  width?: string;
  control: any;
  autocomplete?: string;
  lengthInput?: number;
  preventNotNumbers?: boolean;
  endAdornment?: JSX.Element;
  onCallBack?: () => void;
  onClick?: (event: React.MouseEvent<HTMLInputElement>) => void;
};

export function Input({
  type,
  errorText,
  mask,
  name,
  control,
  color,
  lengthInput,
  width,
  preventNotNumbers,
  endAdornment,
  onCallBack,
  autocomplete,
  onClick,
  ...props
}: Props) {
  const {
    field: { value, ref, onChange },
  } = useController({
    name,
    control,
  });
  const [showPassword, setShowPassword] = useState(false);
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    onChange(e);
    props.onChange?.(e);
  };
  return (
    <Container>
      <TextField
        type={type === 'password' && showPassword ? 'text' : type === 'searchInput' ? 'text' : type}
        {...props}
        ref={ref}
        autoComplete={autocomplete ?? 'off'}
        inputMode={preventNotNumbers ? 'numeric' : undefined}
        onChange={handleChange}
        onClick={onClick}
        value={mask ? toPattern(value ?? '', mask) : value}
        color={color}
        style={{ width }}
        onKeyPress={
          preventNotNumbers
            ? (e) => {
              const isNumber = /^[0-9]$/.test(e.key);
              if (!isNumber) {
                e.preventDefault();
              }
            }
            : undefined
        }
        inputProps={{
          maxLength: lengthInput,
          max: 999,
          min: 1,
          ...(preventNotNumbers && { inputMode: 'numeric', pattern: '[0-9]*' }),
        }}
        InputProps={{
          endAdornment: (
            <>
              {type === 'password' && (
                <IconButton
                  color={color}
                  type="button"
                  className="iconBtn"
                  onClick={() => setShowPassword((state) => !state)}>
                  {showPassword ? <RemoveRedEye color={color} /> : <VisibilityOff color={color} />}
                </IconButton>
              )}
              {type === 'searchInput' && (
                <IconButton color={color} type="button" className="iconBtn" onClick={onCallBack}>
                  <Search />
                </IconButton>
              )}
              {endAdornment && endAdornment}
            </>
          ),
        }}
      />

      {errorText && (
        <span className="fieldError">
          <ErrorIcon fontSize="inherit" /> {errorText}
        </span>
      )}
    </Container>
  );
}
